import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./style.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import Table from "../../../views/Table/Table.js";

import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";

const NonApprovedOrder = (props) => {
  const [data, setData] = React.useState(false);

  // console.log(props)
  console.log(data);
  console.log("ORDER ID : " + props.orders._id);
  React.useEffect(() => {
    axios({
      url: "/getNotApprovedList",
      method: "post",
      data: {
        orderId: props.orders._id,
      },
    })
      .then((res) => {
        console.log(res);
        if (res.data.data.length > 0) {
          setData(res.data.data);
          console.log(res.data.data);
        } else {
          setData("NO_DATA");
        }
      })
      .catch((err) => {
        console.log(err);
        props.onClose();
      });
  }, [props.orders._id]);

  let orders = [];
  let serialNumber = 0;
  data &&
    data != "NO_DATA" &&
    data.forEach((val) => {
      serialNumber++;
      orders.push([
        serialNumber,
        val.productPartId && val.productPartId.partName,
        val.productPartId && val.productPartId.parts_barcode,
        val.productPartId && val.partUnitCode,
        val.productPartId && val.productPartId.length,
        val.productPartId && val.productPartId.width,
        val.productPartId && val.productPartId.weight,
        val.productPartId && val.productPartId.height,
        val.productPartId && val.status,
      ]);
    });

  const isLoading = !data;
  const showData = data;
  const order = props.order;

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>Order Product / Parts</h1>
            <IconButton onClick={props.onClose}>
              <CloseRoundedIcon />
            </IconButton>
          </div>

          {showData == "NO_DATA" && (
            <div className={styles.emptyList}>
              <p>No parts left</p>
            </div>
          )}

          {showData && showData != "NO_DATA" && (
            <div className={styles.content}>
              <h2>Product Part Details</h2>
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Sl No",
                  "Part Name",
                  "Part Code",
                  "Part Unit Code",
                  "Length",
                  "Width",
                  "Weight",
                  "Height",
                  "Status",
                ]}
                tableData={orders}
              />
            </div>
          )}

          {isLoading && (
            <div className={styles.loader}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default NonApprovedOrder;
